<template>
  <div class="fenxijieguo-layer">
    <!-- 标题区域 -->
    <div class="header-section">
      <h2 class="page-title">分析结果</h2>
      <p class="page-subtitle">根据您的贷款需求，我们已为您提供以下分析结果</p>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-container">
      <!-- 贷款基本信息 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>贷款信息（模拟场景利率水平：1年期LPR为3.0%，5年期LPR为3.5%）</h3>
        </div>

        <div class="form-grid" v-if="fastgptResponseloanAmount">
          <p style="font-size: 16px;">你的最终贷款额度为：<span style="font-size: 24px; color: #FF4D4F;">{{ fastgptResponseloanAmount }}</span></p>
        </div>
      </div>

      <!-- 贷款详情：等额本金/等额本金 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>贷款详情：{{ repaymentMethod }}</h3>
        </div>

        <div class="form-grid">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="month" label="期数"></el-table-column>
            <el-table-column prop="payment" label="还款额"></el-table-column>
            <el-table-column prop="principal" label="本金"></el-table-column>
            <el-table-column prop="interest" label="利息"></el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-section">
        <el-button class="prev-btn" @click="handlePrev">
          上一步
        </el-button>
        <el-button class="reset-btn" @click="handleReset">
          重置
        </el-button>
        <el-button type="primary" class="submit-btn" @click="handleSumbit">
          交卷
        </el-button>
      </div>
    </div>

     <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading" :isShowLoading="loading" loadingTxt="智能体分析中，请稍后...">
      </zdyloading>
    </div>
  </div>
</template>

<script>
import apiUser from "@/api/user";
import zdyloading from '@/components/Zdyloading.vue'
import axios from 'axios'
axios.defaults.timeout = 300000
axios.defaults.withCredentials = false
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

export default {
  name: '',
  components: {
    zdyloading
  },
  props: {},
  data () {
    return {
      apiUrl: window.FastGptApiUrl + '/api/v1/chat/completions',
      loading: false,
      fastgptResponseloanAmount: null,
      repaymentMethod: '',
      tableData: []
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    this.repaymentMethod = JSON.parse(sessionStorage.getItem('loanInfo'))?.repaymentMethod || ''
    this.getFastgptResponse()
   },
  methods: {
     getFastgptResponse () {
        let dkedyc_key = sessionStorage.getItem('dkedyc_key')
        this.loading = true
        const  personInfo = JSON.parse(sessionStorage.getItem('personInfo')) || {}
        const {assetInfo ,creditInfo ,queryInfo} = JSON.parse(sessionStorage.getItem('creditHistory')) || {}
        let variables = {
            "uid": "asdfadsfasfd2323",
            "name": personInfo?.name || "张三",
            "input": {
                "姓名":personInfo?.name || "王伟",
                "年龄":personInfo?.age +'岁' || "38岁",
                "职业":personInfo?.job || "软件工程师",
                "从业年限":personInfo?.workYears +'年' || "12年",
                "月收入":personInfo?.monthlyIncome +'元' || "28,000元",
                "月支出":personInfo?.monthlyExpense +'元' || "13,000元",
                "社保缴纳":personInfo?.socialSecurity == '是' ? '正常缴纳' : '未缴纳',
                "公积金缴纳":personInfo?.accumulatedFund == '是' ? '正常缴纳' : '未缴纳',
                "婚姻状况":personInfo?.maritalStatus || "已婚",
                "房产数量":assetInfo?.houseCount +'套' || "1套",
                "房产估值":assetInfo?.houseTotalValue ? assetInfo?.houseTotalValue +'元' : '无' || "420万元",
                "车辆数量":assetInfo?.carCount +'辆' || "1辆",
                "车辆估值":assetInfo?.carValue ? assetInfo?.carValue +'元' : '无' || "18万元",
                "活期存款":assetInfo?.currentSavings ? assetInfo?.currentSavings +'元' : '无' || "85,000元",
                "现有贷款":creditInfo?.existingLoanValue || "1500000",
                "历史逾期次数":creditInfo?.historyOverdueCount +'次' || "1次",
                "失信人记录":creditInfo?.isHistoryOverdue ? '有' : '无',
                "征信查询记录":queryInfo?.creditQueryCount +'次' || "近半年3次"
            }
        }
        // 生成一个唯一的chatId
        const chatId = new Date().getTime()
        console.log("variables", variables)    
        axios({
          headers: {
            'Authorization': `Bearer ${dkedyc_key}`
          },
          url: this.apiUrl,
          method: 'POST',
          data: {
            "stream": false,
            "detail": false,
            "chatId": chatId,
            "variables": variables,
            "messages": [
              {
                "content": "开始出题",
                "role": "user"
              }
            ]
          }
        }).then(res => {
          this.loading = false
          if (res?.data && (res.status == 200 || res.status == 304)) {
            let data = res.data
            if (data.code == 514 || data.code == 403) {
              this.$alert('工作流API秘钥不正确，请检查！')
              return
            } else {
              let text = data.choices[0].message.content || ''
              console.log("text>>>>",text);
              if(text.indexOf('</think>') > -1){
                text = text.split('</think>')[1]
              }
              // 提取最终贷款额度
              // 将 /n/n[最终贷款额度]：1500000 提取出来
              let loanAmountMatch = this.extractNumber(text)
              if (loanAmountMatch) {
                this.fastgptResponseloanAmount = loanAmountMatch
                console.log("fastgptResponseloanAmount>>>",this.fastgptResponseloanAmount);
                // 模拟预览计算
                this.previewPayment()
              }else{
                this.$alert('你搭建的智能体有误，请重置后再试！')
              }

            }
          }else{
            this.$alert('你搭建的智能体有误，请重置后再试！')
          }
        }).catch((err) => {
          console.log("Err>>>", err);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        })
      
    },
    // 从字符串中提取数字
    extractNumber(str) {
        // const str = "/n/n[最终贷款额度]：1500000";
        // 方法1：匹配包含逗号的数字
        const matchWithComma = str.match(/[\d,]+/);
        let extractedNumber = null;
        if (matchWithComma) {
            extractedNumber = matchWithComma[0];
            // console.log('带逗号的数字:', extractedNumber);
            // 移除逗号并转换为数值
            const numericValue = parseInt(extractedNumber.replace(/,/g, ''), 10);
            // console.log('数值类型:', numericValue, typeof numericValue);
            return numericValue
        }
        return null;
    },

    // 根据fastgpt返回的金额，去计算还款详情
    previewPayment(){
      let loanInfo = sessionStorage.getItem('loanInfo')
      const loanAmount = this.fastgptResponseloanAmount
      // const { loanAmount, loanTerm, repaymentMethod } = this.loadInfo;
      const { loanTerm, repaymentMethod } = JSON.parse(loanInfo);
      
      // 验证输入数据
      if (!loanAmount || !loanTerm || !repaymentMethod) {
        return;
      }
      
      // 计算还款信息
      const paymentInfo = this.calculateMonthlyPayment(parseFloat(loanAmount), parseInt(loanTerm), repaymentMethod);
      
      // 生成还款计划表
      this.tableData = this.generateRepaymentSchedule(parseFloat(loanAmount), parseInt(loanTerm), paymentInfo);

       // 在控制台输出计算结果供调试
      console.log(`贷款金额: ¥${loanAmount}, 期限: ${loanTerm}个月, 方式: ${repaymentMethod}`);
      console.log(`总利息: ¥${paymentInfo.totalInterest.toFixed(2)}`);
      console.log(`总还款: ¥${paymentInfo.totalPayment.toFixed(2)}`);
    },

    // 分别计算等额本息和等额本金 1年期LPR为3.0%，5年期以上LPR为3.5%
    calculateMonthlyPayment (loanAmount, loanTerm, repaymentMethod) {
      // 根据贷款期限确定利率
      const annualRate = loanTerm <= 12 ? 0.03 : 0.035; // 1年期3.0%，5年期以上3.5%
      const monthlyRate = annualRate / 12; // 月利率
      
      if (repaymentMethod === '等额本息') {
        // 等额本息计算公式：每月还款额 = [贷款本金 × 月利率 × (1 + 月利率)^还款月数] ÷ [(1 + 月利率)^还款月数 - 1]
        const monthlyPayment = (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanTerm)) / 
                              (Math.pow(1 + monthlyRate, loanTerm) - 1);
        return {
          type: '等额本息',
          monthlyPayment: monthlyPayment,
          monthlyRate: monthlyRate,
          totalPayment: monthlyPayment * loanTerm,
          totalInterest: monthlyPayment * loanTerm - loanAmount
        };
      } else if (repaymentMethod === '等额本金') {
        // 等额本金计算公式：每月还款额 = (贷款本金 ÷ 还款月数) + (本金 - 已归还本金累计额) × 月利率
        const monthlyPrincipal = loanAmount / loanTerm; // 每月本金
        const firstMonthPayment = monthlyPrincipal + loanAmount * monthlyRate; // 首月还款
        const lastMonthPayment = monthlyPrincipal + monthlyPrincipal * monthlyRate; // 末月还款
        const totalInterest = (loanAmount * monthlyRate * (loanTerm + 1)) / 2; // 总利息
        
        return {
          type: '等额本金',
          monthlyPrincipal: monthlyPrincipal,
          monthlyRate: monthlyRate,
          firstMonthPayment: firstMonthPayment,
          lastMonthPayment: lastMonthPayment,
          totalPayment: loanAmount + totalInterest,
          totalInterest: totalInterest
        };
      }
    },
    
    // 生成还款计划表
    generateRepaymentSchedule (loanAmount, loanTerm, paymentInfo) {
      const schedule = [];
      
      if (paymentInfo.type === '等额本息') {
        // 等额本息还款计划
        let remainingPrincipal = loanAmount;
        const monthlyPayment = paymentInfo.monthlyPayment;
        
        for (let month = 1; month <= loanTerm; month++) {
          const interestPayment = remainingPrincipal * paymentInfo.monthlyRate;
          const principalPayment = monthlyPayment - interestPayment;
          remainingPrincipal -= principalPayment;
          
          schedule.push({
            month: `第${month}期`,
            payment: `¥${monthlyPayment.toFixed(2)}`,
            principal: `¥${principalPayment.toFixed(2)}`,
            interest: `¥${interestPayment.toFixed(2)}`,
            remaining: `¥${Math.max(0, remainingPrincipal).toFixed(2)}`
          });
        }
      } else if (paymentInfo.type === '等额本金') {
        // 等额本金还款计划
        let remainingPrincipal = loanAmount;
        const monthlyPrincipal = paymentInfo.monthlyPrincipal;
        
        for (let month = 1; month <= loanTerm; month++) {
          const interestPayment = remainingPrincipal * paymentInfo.monthlyRate;
          const monthlyPayment = monthlyPrincipal + interestPayment;
          remainingPrincipal -= monthlyPrincipal;
          
          schedule.push({
            month: `第${month}期`,
            payment: `¥${monthlyPayment.toFixed(2)}`,
            principal: `¥${monthlyPrincipal.toFixed(2)}`,
            interest: `¥${interestPayment.toFixed(2)}`,
            remaining: `¥${Math.max(0, remainingPrincipal).toFixed(2)}`
          });
        }
      }
      
      return schedule;
    },

    handlePrev () {
      this.$emit('prevStep', 'monigerenzhengxinbaogao');
    },
    handleReset () {
      sessionStorage.removeItem('chatId');
      sessionStorage.removeItem('variables');
      sessionStorage.removeItem('creditHistory');
      sessionStorage.removeItem('dkedyc_key');
      sessionStorage.removeItem('loanInfo');
      sessionStorage.removeItem('personInfo');
      this.$message({
        message: '重置成功！',
        type: 'success'
      });
      this.$emit('nextStep', 'gerenyushouruxinxi');
    },
    // 交卷
    handleSumbit () {
      this.$confirm('点击确认将交卷', '提示').then(() => {
        // 调用 交卷接口
        let dygptaccount
        let type = sessionStorage.getItem('casetype')
        if (type == 1) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_AL'
        } else if (type == 2) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_GZL'
        } else {
          dygptaccount = sessionStorage.getItem('dygptaccount')
        }
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        apiUser.CaseSubmit({
          caseId: sessionStorage.getItem('caseno'),
          studentUsername: dygptaccount,
          userId: userInfo.f_Id,
          mode: type == 1 ? 2 : 1,// 接口中类型标识：1=工作流案例，2=场景类型
        }
        ).then((res) => {
          console.log(res);
          if (res) {
            // this.$message({ type: res.code == 200 ? 'success' : 'warning', message: res.message })
            console.log("res>>>", res);
          }
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/case/caseselect'
          })
          // 清除API秘钥缓存
          sessionStorage.removeItem('xlznt_jf_key')
          sessionStorage.removeItem('xlznt_tw_key')
          sessionStorage.removeItem('znkf_key')

          sessionStorage.removeItem('chatId');
          sessionStorage.removeItem('variables');
          sessionStorage.removeItem('creditHistory');
          sessionStorage.removeItem('dkedyc_key');
          sessionStorage.removeItem('loanInfo');
          sessionStorage.removeItem('personInfo');
        }, 500);
      })
     
    }
  }
}
</script>

<style scoped lang="less">
.fenxijieguo-layer {
  height: 100%;
  box-sizing: border-box;
  color: #fff;
  overflow: auto;
}

// 标题区域
.header-section {
  text-align: center;
  margin-bottom: 30px;

  .page-title {
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 10px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .page-subtitle {
    font-size: 14px;
    color: #b8c4e0;
    margin: 0;
  }
}

// 内容容器
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

// 区块通用样式
.form-section,
.assessment-section {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  padding: 25px;
  backdrop-filter: blur(10px);
}

// 区块标题
.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  .title-icon {
    width: 4px;
    height: 20px;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border-radius: 2px;
  }

  h3 {
    font-size: 18px;
    color: #fff;
    margin: 0;
    font-weight: 600;
  }
}

// 操作区域
.action-section {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(21, 73, 243, 0.2);

  .submit-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .reset-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }

  .prev-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }
}

.dd-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);

  /deep/ .loading-text {
    color: #fff;
  }
}
</style>
